import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import { Ability } from 'ember-can';

export default class BaseAbility extends Ability {
  // Services
  @service permission;

  // Defaults
  @tracked model;
  @tracked recordType;
  @tracked parentModel;

  // Getter and setter
  get actions() {
    return this.permissions?.actions;
  }

  get canBlockEntity() {
    return this.actions?.blockEntity;
  }

  get canCreate() {
    return this.actions?.create;
  }

  get canDelete() {
    return this.actions?.delete;
  }

  get canRead() {
    return this.actions?.read;
  }

  get canUpdate() {
    return this.actions?.update;
  }

  get canUnlockEntity() {
    return this.actions?.unlockEntity;
  }

  get canViewMetaData() {
    return this.permissions?.options?.canViewMetaData ?? true;
  }

  get canViewNavigation() {
    return this.permissions?.options?.canViewNavigation ?? this.actions?.read;
  }

  get canViewVariants() {
    return this.permissions?.options?.canViewVariants ?? true;
  }

  get permissions() {
    return this.permission.for(this.recordType);
  }
}
